import React from 'react';
import { Button } from '@shopify/polaris';

const ButtonCustom = ({
    className = '',
    label = '',
    isDisabled,
    children,
    ...props
}) => {
    return (
        <div className={`ButtonCustom ${className} ${isDisabled ? 'disabled' : ''}`}>
            <Button {...props}>{props.loading ? '' : children}</Button>
        </div>
    )
}

export default ButtonCustom;